import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { ChatSoporteService } from 'src/app/shared/services/chat-soporte.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'chat-soporte',
  templateUrl: './chat-soporte.component.html',
  styleUrls: ['./chat-soporte.component.css']
})
export class ChatSoporteComponent implements OnInit {

  mostrarChat = 0;

  @Output() cerrarChatEvent = new EventEmitter();

  cerrarChat() {
    this.cerrarChatEvent.emit(this.mostrarChat);
  }

  constructor(
    public chatService: ChatSoporteService, 
    private afs: AngularFirestore) { }

  chat = [];
  status = "";
  usuario = JSON.parse(localStorage.getItem("user"))
  mensaje = "";
  loaded = 0;

  async ngOnInit() {
      this.chatService.leido(this.usuario.uid)
      await this.chatService.validar(this.usuario.uid)
      this.chatService.getChat(this.usuario.uid).subscribe((snap) => {
        this.chat = snap.payload.data()["chat"];
        this.status = snap.payload.data()["status"];
        this.loaded = 1;
        var myDiv = document.getElementById("messagesContainer");
        myDiv.scrollTop = myDiv.scrollHeight;
      })
  }

  scrollDown(){
    var myDiv = document.getElementById("messagesContainer");
    myDiv.scrollTop = myDiv.scrollHeight;
  }

  async enviarMensaje() {
    await this.chatService.leido(this.usuario.uid)
    this.chatService.pushMessage(
      this.usuario.uid,
      {
        usuario: this.usuario.nombreCompleto,
        mensaje: this.mensaje,
        admin: false,
      }
    )
    this.mensaje = "";
  }

}
